import {Question} from "../../formation";

export class Reponse {
    constructor(
        public id?: number,
        public response?: string,
        public question?: Question,
        public candidatureFormationId?: number,
        //calculé par le back mais pas systématiquement présent
        public ordreCategorie?: number,
        public ordreGlobal?: number

    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/formation/reponse.model.ts